import { Typography, alpha } from '@mui/material';
import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TargetDoseBadge from '~/components/DoseItem/TargetDoseBadge';
import CopyField from '~/components/Fields/CopyField';
import TargetIcon from '~/components/Structures/TargetIcon';
import { DoseStatisticsRow } from '~/containers/viewer/table-panel/DoseStatisticsTable';
import useDoseTargetLookup from '~/hooks/patient/dose/useDoseTargetLookup';

export default function DoseStatisticsTableRow({
    row,
}: {
    row: DoseStatisticsRow;
}) {
    const targetDoseLookup = useDoseTargetLookup();
    const targetDoseGy = targetDoseLookup.get(row.structure);
    const isTarget = targetDoseGy !== undefined;

    return (
        <TableRow
            key={row.id}
            sx={(theme) => ({
                backgroundColor: isTarget
                    ? alpha(theme.palette.primary.main, 0.08)
                    : undefined,
            })}
        >
            <TableCell>
                <Box display="flex" alignItems="center" gap={1}>
                    {isTarget ? (
                        <Box mr={1} display="flex">
                            <TargetIcon color={row.color} size={11} />
                        </Box>
                    ) : (
                        <Box
                            height={10}
                            width={10}
                            borderRadius="100%"
                            bgcolor={row.color}
                            mr={1}
                        />
                    )}
                    <Typography
                        fontSize={13}
                        fontWeight={isTarget ? 500 : undefined}
                        noWrap
                        sx={{ minWidth: 0 }}
                    >
                        {row.structure}
                    </Typography>
                    {isTarget && (
                        <TargetDoseBadge
                            doseQuantityGy={targetDoseGy}
                            structureName={row.structure}
                        />
                    )}
                </Box>
            </TableCell>
            <TableCell>
                <CopyField label={row.minDoseGy.toFixed(1)} size={12} />
            </TableCell>
            <TableCell>
                <CopyField label={row.maxDoseGy.toFixed(1)} size={12} />
            </TableCell>
            <TableCell>
                <CopyField label={row.meanDoseGy.toFixed(1)} size={12} />
            </TableCell>
        </TableRow>
    );
}
